export const executive = [
    {
        name: 'Alexandre Pacheco',
        title: 'Diretor Executivo',
        linkedin: 'https://www.linkedin.com/in/alexandre-pacheco-cea-487404156/',
        avatar: 'profile-alexandre-pacheco.jpg'
    },
    {
        name: 'João Paulo Borges',
        title: 'Head Centro-Oeste',
        linkedin: 'https://www.linkedin.com/in/jo%C3%A3o-paulo-borges-4267b445/ ',
        avatar: 'profile-joao-paulo-borges.jpg'
    }
]

const loadEntries = entries => {
    Promise.all(
        entries.map(entry => {
            if (entry.img) { // just load on webpack build
                import(`../media/${entry.avatar}`)
            }
        })
    )
}

loadEntries(executive)

export default [
    {
        id: 'liderança',
        name: 'Lideranças',
        members: executive
    }
]
